module.exports = __webpack_public_path__ + "static/googleplay-4bd19e9a6de49d08bd7eddf4c675fb62.png";